import { useMutation } from '@apollo/client';
import { UPDATE_USER_MUTATION } from 'Account/withUpdateUser';
import { UpdateUserInput } from '__generated__/globalTypes';
import isNil from 'lodash/isNil';

interface Variables {
  userInput: Partial<UpdateUserInput>;
}

interface WithUpdateUserResponse {
  updateUser?: string;
}

interface Response {
  error?: string;
}

const useUpdateUser = () => {
  const [mutate, { loading }] = useMutation<WithUpdateUserResponse, Variables>(
    UPDATE_USER_MUTATION,
  );

  const updateUser = async (
    userInput: Partial<UpdateUserInput>,
  ): Promise<Response> => {
    try {
      const { data } = await mutate({
        variables: { userInput },
      });

      if (data && !isNil(data.updateUser)) {
        return {};
      }
    } catch (error) {
      return {
        error: `Update user failed: ${error}`,
      };
    }

    return {
      error: 'An unknown error occurred while updating user.',
    };
  };

  return { updateUser, loading };
};

export default useUpdateUser;
